import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Grid,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Snackbar,
  CircularProgress,
} from '@mui/material';

import { store } from 'js/core/configureStore';
import { userFormAction } from 'js/core/actions/userFormActions.js';
import cfac22 from 'js/library/utils/cfac22';

const UserForm = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const cellPhoneFromStore = store.getState().phoneInputModel.cellPhone;

  const [cellPhone] = useState(cellPhoneFromStore);
  const [aliasName, setAliasName] = useState('');
  const [optin1, setOptin1] = useState(true);
  const [optin2, setOptin2] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState('');

  const reduxLoading = useSelector((state) => state.userFormComponent.loading);

  const handleChange = useCallback((name, value) => {
    switch (name) {
      case 'aliasName':
        setAliasName(value);
        break;
      case 'optin1':
        setOptin1(value);
        break;
      case 'optin2':
        setOptin2(value);
        break;
      default:
        break;
    }
  }, []);

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();

      if (aliasName.length < 2) {
        setMessageSnackbar('Digite um apelido com no mínimo 2 caracteres.');
        setOpenSnackbar(true);
        return;
      }

      if (!optin1) {
        // Mostrar o dialog, mas sem uso prático aqui
        setMessageSnackbar('O aceite dos termos e condições é obrigatório.');
        setOpenSnackbar(true);
        return;
      }

      setLoading(true);
      dispatch(userFormAction(dispatch, aliasName, cellPhone, optin1, optin2));
    },
    [aliasName, cellPhone, optin1, optin2, dispatch]
  );

  if (window.pathname !== null) {
    window.top.location = window.pathname;
  }

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: 'calc(100vh - 105px)' }}
      className="background-login"
    >
      <div style={{ width: 500, maxWidth: '100%', padding: 15 }}>
        <Typography
          style={{ fontWeight: 'bold' }}
          color="secondary"
          variant="subtitle1"
          gutterBottom
        >
          {t('how_it_works.please_inform_your_data')}
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }} style={{ marginBottom: 15 }}>
              <TextField
                fullWidth
                required
                type="text"
                value={aliasName}
                id="nickname"
                label="Apelido"
                onChange={(e) => handleChange('aliasName', e.target.value)}
              />
            </Grid>
          </Grid>

          <FormControlLabel
            id="optin1"
            control={
              <Checkbox
                checked={optin1}
                onChange={(e) => handleChange('optin1', e.target.checked)}
              />
            }
            label={t('general.accept_terms_and_conditions')}
          />

          <FormControlLabel
            id="optin2"
            control={
              <Checkbox
                checked={optin2}
                onChange={(e) => handleChange('optin2', e.target.checked)}
              />
            }
            label={t('general.accept_to_receive_communications')}
          />

          <div style={{ padding: '20px 0px' }}>
            <a href={cfac22('termsOfUseUrl')} target="new">
              <Typography id="ToS" variant="caption" gutterBottom>
                <u>{t('general.show_terms_and_conditions')}</u>
              </Typography>
            </a>
          </div>

          <Button
            fullWidth
            style={{ textTransform: 'initial' }}
            disabled={reduxLoading || loading}
            variant="contained"
            color="primary"
            type="submit"
          >
            {reduxLoading || loading ? (
              <CircularProgress size="2rem" style={{ color: 'white' }} />
            ) : (
              <Typography variant="h6">{t('general.register')}</Typography>
            )}
          </Button>
        </form>

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={openSnackbar}
          onClose={() => setOpenSnackbar(false)}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{messageSnackbar}</span>}
        />
      </div>
    </Grid>
  );
};

export default UserForm;

